import TitleMain from './TitleMain';

export default TitleMain;
export * from './TitleMain';
